const SectionSkeleton = ({ height = 300 }: { height?: number }) => (
  <div
    style={{
      height,
      background: "#f2f2f2",
      borderRadius: 8,
      marginBottom: 40,
      animation: "pulse 1.2s infinite"
    }}
  />
);

export default SectionSkeleton;
